import * as React from 'react';
import { ProductInterface } from '../../../Model/Product';
import { AttributeUtility } from '../../../Service/AttributeUtility';
import { AbstractRow } from '../AbstractRow';
import { AttributeCell } from '../AttributeCell';
import { FinderImage } from '../FinderImage';
import { HeadlineCell } from '../HeadlineCell';
import { MiscCell } from '../MiscCell';
import { WatchlistCell } from '../WatchlistCell';

export class AmplifierRow extends AbstractRow {
    public renderCells() {
        const product = this.props.product;
        const protectionClasses = AttributeUtility.childAttributesForKeyFiltered([product], 'Schutzart');

        return <>
            <td><FinderImage product={product} attr="Produktgruppenbild"/></td>
            <AttributeCell product={product} attr="Produktgruppenbeschreibung_kurz"/>
            <AttributeCell product={product} attr="Kundennutzen"/>
            <AttributeCell product={product} attr="Anzahl_Kanaele" extra={true}/>
            <AttributeCell product={product} attr="Anzahl_Kraftaufnehmer" extra={true}/>
            <AttributeCell product={product} attr="Technologie" extra={true}/>
            <AttributeCell product={product} attr="Feldbus" extra={true}/>
            <AttributeCell product={product} attr="Schutzart" extra={true}>
                <ul>{protectionClasses.map(
                    protectionClass => <li key={protectionClass.displayString + product.guid}>
                        {protectionClass.displayString}
                    </li>
                )}</ul>
            </AttributeCell>
            <MiscCell product={product}
                      datasheetAttr='Datenblatt'
                      manualAttr='Bedienungsanleitung'
                      dataAcquisitionAttr="Datenerfassungsformular"/>
        </>;
    }

    protected renderHeadline(product: ProductInterface): JSX.Element {
        return <>
            <HeadlineCell colSpan={3} product={product} attr="name"/>
            <WatchlistCell product={product}/>
        </>;
    }
}
